<div class="container-fluid">
	<h1 class="text-capitalize my-3">{{shipping_info?.shipping?.id ? 'Actualizar':'Agregar'}} Envío</h1>
	<form id="save-shipping" (submit)="save($event)" ngNativeValidate>
		<div class="card py-3 px-1 px-lg-3 shadow">
			<div class="row">
				<div class="col-6 col-md-4">
					<label class=""># Económico o Guía</label>
					<input type="text" name="shipping_guide" [(ngModel)]="shipping_info.shipping.shipping_guide" placeholder="xxxxxx" class="form-control" [disabled]="shipping_info.shipping.status != 'PENDING'" required>
				</div>
				<div class="col-6 col-md-4">
					<label class="">Nombre chofer/Paqueteria</label>
					<input type="text" name="shipping_company" [(ngModel)]="shipping_info.shipping.shipping_company" placeholder="Jesus martinez" class="form-control" [disabled]="shipping_info.shipping.status != 'PENDING'" required>
				</div>
				<div class="col-6 col-md-4" *ngIf="!shipping_info.shipping.purchase_id">
					<label class="">Almacén Origen </label>
					<select name="from_store_id" [ngModel]="from_store_id" (ngModelChange)="onFromStoreChange($event)" class="form-control" [disabled]="shipping_info.shipping.status == 'SENT'  || !!(shipping_info?.shipping?.requisition_id) || (!rest.current_permission.global_send_shipping)" required>
						<option [ngValue]="null">Seleccionar</option>
						<option *ngFor="let c of store_list" [value]="c.id">{{c.name | titlecase}}</option>
					</select>
				</div>
				<div class="col-6 col-md-4">
					<label class="">Almacén Destino</label>
					<select name="to_store_id" [ngModel]="to_store_id" (ngModelChange)="onToStoreChange($event)" class="form-control" [disabled]="(!!shipping_info?.shipping?.requisition_id)" required>
						<option value="">Seleccionar</option>
						<option *ngFor="let c of store_list" [value]="c.id">{{c.name | titlecase}}</option>
					</select>
				</div>
				<div class="col-6 col-md-4">
					<label class="">Fecha de envío</label>
					<input type="date" name="date" [(ngModel)]="shipping_info.shipping.date" class="form-control" placeholder="YYYY-mm-dd" [disabled]="shipping_info.shipping.status != 'PENDING'" required>
				</div>
				<div class="col-6 col-md-4">
					<label class="">Nota</label>
					<input type="note" name="note" [(ngModel)]="shipping_info.shipping.note" class="form-control" placeholder="Motivo del envío">
				</div>
			</div>
		</div>
	</form>
	<div *ngIf="requisition_info" class="d-flex justify-content-between my-3">
		<h4>Requisición
			<b>#{{requisition_info.requisition.id}}</b>
		</h4>
		<button *ngIf="rest.current_permission.shipment_quick_add_item" type="button" class="btn btn-primary" (click)="addAllRequisitionItems()">
			Agregar todos</button>
	</div>
	<app-loading [is_loading]="is_loading"></app-loading>
	<div *ngIf="requisition_info" class="card p-3 shadow">
		<div class="row d-none d-md-flex">
			<div class="col-4 fw-bold">Artículo</div>
			<div class="col-4 text-end fw-bold">Cantidad Solicitada</div>
			<div class="col-3 text-end fw-bold">Cantidad a Enviar</div>
			<div class="col-1 text-end fw-bold">Acciones</div>
		</div>
		<div class="row border-bottom pb-2" *ngFor="let rii of requisition_info.items">
			<div class="col-12 col-md-4 fw-bold">
				<a routerLink="/list-item" [queryParams]="{item_id:rii.item.id}">{{rii | itemName}}</a>
				<span *ngIf="rest.local_preferences.display_item_identifier == 'CODE' || rest.local_preferences.display_item_identifier == 'BOTH'">{{rii.item.code}}</span>
				<span *ngIf="(rest.local_preferences.display_item_identifier == 'TAGS' || rest.local_preferences.display_item_identifier == 'BOTH') && rii.item.json_tags?.length">
					<span *ngFor="let tag of rii.item.json_tags"> {{tag | uppercase}}</span>
				</span>
			</div>
			<div class="col-6 d-md-none fw-bold">Cantidad Solicitada</div>
			<div class="col-6 col-md-4 text-end">{{rii?.requisition_item?.qty | number }}</div>
			<div class="col-6 d-md-none fw-bold">Cantidad a enviar</div>
			<div class="col-6 col-md-3 text-end">{{qty_by_item_id[ rii.item.id ] || 0 | number }}</div>
			<div class="col-6 col-md-1 text-end">
				<button *ngIf="rest.current_permission.shipment_quick_add_item" type="button" class="btn-primary" (click)="addRequistionItem(rii)">+</button>
			</div>
		</div>
	</div>
	<div class="card my-3 py-3 px-1">
		<div class="row">
			<div class="col-12 col-lg-4 form-group">
				<app-search-items (item_selected)="onItemSelected($event)" [reset_on_search]="true"></app-search-items>
			</div>
		</div>
		<div class="container-fluid">
			<div class="row d-none d-lg-flex">
				<div class="col-5">Nombre</div>
				<div class="col-2 text-end">Disponibles</div>
				<div class="col-2 text-end">Cantidad</div>
				<div class="col-1 text-center">Lotes</div>
				<div class="col-2 text-end">Acciones</div>
			</div>
			<div class="row align-items-center border-bottom mb-3 mb-1 pb-3" *ngFor="let sii of shipping_info.items;let i=index">
				<div class="col-9 col-lg-5 pb-3 px-1 pb-lg-0">
					<img [src]="rest.getImagePath(sii.item.image_id,sii?.category?.image_id)" style="max-height:30px;max-width:30px;margin-right:10px">
					<a routerLink="/list-item" [queryParams]="{'csv.id':sii.item.id}">
						<span *ngIf="sii.category">{{sii?.category?.name | titlecase}}</span>
						{{sii.item.name | titlecase }}
						<b *ngIf="rest.local_preferences.display_item_identifier == 'CODE' || rest.local_preferences.display_item_identifier == 'BOTH'">{{sii.item.code}}</b>
						<span *ngIf="(rest.local_preferences.display_item_identifier == 'TAGS' || rest.local_preferences.display_item_identifier == 'BOTH') && sii.item.json_tags?.length">
							<span *ngFor="let tag of sii.item.json_tags"> {{tag | uppercase}}</span>
						</span>
					</a>
					<div *ngIf="sii.shipping_item.serial_number">#{{sii.shipping_item.serial_number}}</div>
				</div>
				<div class="col-3 col-lg-2 pb-3 px-1 pb-lg-0 order-lg-last">
					<button type="button" class="btn btn-primary w-100" (click)="removeItem(sii)">
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.3em" height="1.3em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 20 20"><g fill="none"><path d="M10 1.25a2.75 2.75 0 0 1 2.739 2.5H17a.75.75 0 0 1 .102 1.493L17 5.25h-.583L15.15 16.23A2 2 0 0 1 13.163 18H6.837a2 2 0 0 1-1.987-1.77L3.582 5.25H3a.75.75 0 0 1-.743-.648L2.25 4.5a.75.75 0 0 1 .648-.743L3 3.75h4.261A2.75 2.75 0 0 1 10 1.25zM8.5 7.5c-.245 0-.45.155-.492.359L8 7.938v6.125l.008.078c.042.204.247.359.492.359s.45-.155.492-.359L9 14.062V7.939l-.008-.08C8.95 7.656 8.745 7.5 8.5 7.5zm3 0c-.245 0-.45.155-.492.359L11 7.938v6.125l.008.078c.042.204.247.359.492.359s.45-.155.492-.359l.008-.079V7.939l-.008-.08c-.042-.203-.247-.358-.492-.358zM10 2.75c-.605 0-1.11.43-1.225 1h2.45c-.116-.57-.62-1-1.225-1z" fill="currentColor"/></g></svg>
						<span class="d-none d-md-inline">Eliminar</span>
					</button>
				</div>
				<div class="col-6 col-lg-2 text-lg-end px-1">
					<label class="d-lg-none">Disponibles</label>
					<div>{{sii.available | number}}</div>
				</div>
				<div class="col-6 col-lg-2 text-end px-1">
					<ng-container *ngIf="!sii.shipping_item.serial_number">
						<label class="d-lg-none">Cantidad</label>
						<input form="save-shipping" type="number" [name]="'shippint_item'+sii.shipping_item.item_id" [(ngModel)]="sii.shipping_item.qty" (ngModelChange)="updateValues()" class="form-control text-end" [step]="sii.item.partial_sale == 'NO'?'1':'any'" required>
					</ng-container>
				</div>
				<div class="col-6 col-lg-1 text-center px-1" *ngIf="requiresBatchInfo(sii.item)">
					<label class="d-lg-none">Lotes</label>
					<button type="button" class="btn btn-sm" [ngClass]="{'btn-success': isBatchValid(sii), 'btn-warning': !isBatchValid(sii)}" (click)="openBatchModal(sii)" title="Gestionar lotes">
						<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24"><path fill="currentColor" d="M5 21q-.825 0-1.413-.588T3 19V5q0-.825.588-1.413T5 3h14q.825 0 1.413.588T21 5v14q0 .825-.588 1.413T19 21H5Zm0-2h14V5H5v14Zm2-2h10v-2H7v2Zm0-4h10v-2H7v2Zm0-4h10V7H7v2Z"/></svg>
						<span class="d-none d-xl-inline ms-1">{{getBatchSummary(sii)}}</span>
					</button>
				</div>
				<div class="col-6 col-lg-1 text-center px-1" *ngIf="!requiresBatchInfo(sii.item)">
					<!-- Empty space for non-batch items -->
				</div>
			</div>
		</div>
		<div class="row p-3">
			<div class="col-12 text-end">
				<button form="save-shipping" type="submit" [disabled]="is_loading" class="btn btn-primary">
					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.3em" height="1.3em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 20 20"><path d="M15.173 2H4c-1.101 0-2 .9-2 2v12c0 1.1.899 2 2 2h12c1.101 0 2-.9 2-2V5.127L15.173 2zM14 8c0 .549-.45 1-1 1H7c-.55 0-1-.451-1-1V3h8v5zm-1-4h-2v4h2V4z" fill="currentColor"/></svg>
					Guardar
				</button>
			</div>
		</div>
	</div>
</div>

<app-modal [(show)]="show_serial_numbers">
	<div class="p-3">
		<h2 *ngIf="selected_item_info">{{(selected_item_info.category? selected_item_info.category.name+' - ':'')}}{{selected_item_info.item.name}}</h2>
    </div>
	<input *ngIf="serial_list.length>5" type="text" [ngModel]="serial_search" (ngModelChange)="onSerialSearchChange($event)">
	<div>
		<div *ngFor="let s of tmp_serial_list" class="row">
			<div class="col">{{s.serial_info.serial.serial_number}}</div>
			<div class="col">
				<button type="button" (click)="addSerial(s.serial_info.serial.serial_number,s.item_info.item, s.item_info.category)">
					<svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 256 256"><path fill="currentColor" d="M208 32H48a16 16 0 0 0-16 16v160a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16Zm-24 104h-48v48a8 8 0 0 1-16 0v-48H72a8 8 0 0 1 0-16h48V72a8 8 0 0 1 16 0v48h48a8 8 0 0 1 0 16Z"/></svg>
				</button>
			</div>
		</div>
	</div>
</app-modal>

<!-- Batch Entry Modal -->
<app-modal [(show)]="show_batch_modal">
	<div class="p-3" *ngIf="batch_entry_item">
		<h4 class="mb-3">
			Lotes para: {{batch_entry_item.category?.name ? batch_entry_item.category.name + ' - ' : ''}}{{batch_entry_item.item?.name}}
		</h4>
		<div class="mb-3">
			<span class="badge bg-primary me-2">Cantidad a enviar: {{batch_entry_item.shipping_item?.qty}}</span>
			<span class="badge" [ngClass]="{'bg-success': getRemainingBatchQty() === 0, 'bg-warning': getRemainingBatchQty() !== 0}">
				Restante: {{getRemainingBatchQty()}}
			</span>
		</div>

		<!-- Available batches from origin store -->
		<div *ngIf="available_batches.length > 0" class="mb-4">
			<h5>Lotes disponibles en sucursal origen</h5>
			<div class="table-responsive">
				<table class="table table-sm table-bordered">
					<thead>
						<tr>
							<th *ngIf="batch_entry_item.item?.batch_option === 'BATCH_ONLY' || batch_entry_item.item?.batch_option === 'BATCH_AND_EXPIRATION'">Lote</th>
							<th *ngIf="batch_entry_item.item?.batch_option === 'EXPIRATION_ONLY' || batch_entry_item.item?.batch_option === 'BATCH_AND_EXPIRATION'">Caducidad</th>
							<th>Disponible</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let br of available_batches">
							<td *ngIf="batch_entry_item.item?.batch_option === 'BATCH_ONLY' || batch_entry_item.item?.batch_option === 'BATCH_AND_EXPIRATION'">{{br.batch}}</td>
							<td *ngIf="batch_entry_item.item?.batch_option === 'EXPIRATION_ONLY' || batch_entry_item.item?.batch_option === 'BATCH_AND_EXPIRATION'">{{br.expiration_date}}</td>
							<td>{{br.qty | number}}</td>
							<td>
								<button type="button" class="btn btn-sm btn-outline-primary" (click)="addBatchFromAvailable(br)" [disabled]="getRemainingBatchQty() <= 0">
									<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
									Agregar
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- Batch entry rows -->
		<h5>Lotes a enviar</h5>
		<div class="table-responsive">
			<table class="table table-sm">
				<thead>
					<tr>
						<th *ngIf="batch_entry_item.item?.batch_option === 'BATCH_ONLY' || batch_entry_item.item?.batch_option === 'BATCH_AND_EXPIRATION'">Lote</th>
						<th *ngIf="batch_entry_item.item?.batch_option === 'EXPIRATION_ONLY' || batch_entry_item.item?.batch_option === 'BATCH_AND_EXPIRATION'">Caducidad</th>
						<th>Cantidad</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of batch_rows; let idx = index">
						<td *ngIf="batch_entry_item.item?.batch_option === 'BATCH_ONLY' || batch_entry_item.item?.batch_option === 'BATCH_AND_EXPIRATION'">
							{{row.batch}}
						</td>
						<td *ngIf="batch_entry_item.item?.batch_option === 'EXPIRATION_ONLY' || batch_entry_item.item?.batch_option === 'BATCH_AND_EXPIRATION'">
							{{row.expiration_date}}
						</td>
						<td>
							<input type="number" class="form-control form-control-sm" [(ngModel)]="row.qty" min="1" required>
						</td>
						<td>
							<button type="button" class="btn btn-sm btn-outline-danger" (click)="removeBatchRow(idx)">
								<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M19 13H5v-2h14v2z"/></svg>
							</button>
						</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<td [attr.colspan]="(batch_entry_item.item?.batch_option === 'BATCH_AND_EXPIRATION' ? 2 : 1)" class="text-end fw-bold">Total:</td>
						<td class="fw-bold" [ngClass]="{'text-success': getRemainingBatchQty() === 0, 'text-danger': getRemainingBatchQty() !== 0}">{{getTotalBatchQty()}}</td>
						<td></td>
					</tr>
				</tfoot>
			</table>
		</div>


		<div class="d-flex justify-content-end gap-2">
			<button type="button" class="btn btn-secondary" (click)="closeBatchModal()">Cancelar</button>
			<button type="button" class="btn btn-primary" (click)="saveBatchEntries()" [disabled]="getRemainingBatchQty() !== 0">
				<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M21 7L9 19l-5.5-5.5l1.41-1.41L9 16.17L19.59 5.59L21 7z"/></svg>
				Guardar lotes
			</button>
		</div>
	</div>
</app-modal>
